import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { importLibrary, setOptions } from '@googlemaps/js-api-loader';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {
  private readonly googleMapSubj$: BehaviorSubject<typeof google.maps | null> = new BehaviorSubject<typeof google.maps | null>(null);

  public readonly googleMap$: Observable<unknown> = this.googleMapSubj$.pipe(filter((map): map is typeof google.maps => map !== null));

  public load(libraries: string[] = []): Promise<void> {
    setOptions({ key: environment.apiKey, v: 'weekly', region: 'US', language: 'en' });

    return Promise.all(libraries.map(library => importLibrary(library))).then(() => this.googleMapSubj$.next(google.maps));
  }
}
